import type { PlanView } from "@store/plan/planReducer";
import type { ItemDirection } from "@domain/ItemDirection";
import { getCurrentDirections } from "./getCurrentDirections";

const getPolylinePath = (
  directions: ItemDirection[],
  planView: PlanView,
  navigationDirectionIndex: number,
) => {
  const bounds = new google.maps.LatLngBounds();
  // Navigation shows one step at a time, otherwise whole plan route is visible.
  const currentDirections = getCurrentDirections(
    directions,
    planView,
    navigationDirectionIndex,
  );

  const polylinePath = currentDirections?.reduce(
    (acc, x) => {
      const points = x.overviewPolyline.map((y) => {
        const point = { lat: y.latitude, lng: y.longitude };
        bounds.extend(point);
        return point;
      });
      return [...acc, ...points];
    },
    [] as { lat: number; lng: number }[],
  );

  return { polylinePath: polylinePath, bounds: bounds };
};

export { getPolylinePath };
